import { Controller } from "@hotwired/stimulus"
import { createElement, type ComponentType } from "react"
import { createRoot, type Root } from "react-dom/client"

// Each island declares its own Props type; the registry passes whatever JSON
// the data-react-island-props-value attribute parsed to. Type-safety lives
// inside each island, not at this boundary.
type IslandModule = { default: ComponentType<any> } // eslint-disable-line @typescript-eslint/no-explicit-any

// Add each island here when you create it. Lazy imports keep each island's code
// in its own chunk so the schedule grid (large) doesn't ship with the trade
// board (small), etc.
const ISLANDS: Record<string, () => Promise<IslandModule>> = {
  WeekNavigator: () => import("../islands/WeekNavigator"),
  ScheduleGrid: () => import("../islands/ScheduleGrid"),
  ByCoachGrid: () => import("../islands/ByCoachGrid"),
  AvailabilityGrid: () => import("../islands/AvailabilityGrid"),
  ClassBulkAddGrid: () => import("../islands/ClassBulkAddGrid"),
  SolverRunUnfilled: () => import("../islands/SolverRunUnfilled"),
}

export default class extends Controller {
  static values = { component: String, props: Object }

  declare componentValue: string
  declare propsValue: Record<string, unknown>

  private root?: Root

  async connect() {
    const loader = ISLANDS[this.componentValue]
    if (!loader) {
      console.error(`[react-island] Unknown component "${this.componentValue}"`)
      return
    }
    const mod = await loader()
    this.root = createRoot(this.element as HTMLElement)
    this.root.render(createElement(mod.default, this.propsValue))
  }

  disconnect() {
    this.root?.unmount()
    this.root = undefined
  }
}
